import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'bootstrap/dist/css/bootstrap.min.css'
import { registerExtensions } from './utils/extensions'
import api from './api/apiClient'
import VueGtag from "vue-gtag";

Vue.config.productionTip = false;

initGoogleAnalytics();
registerExtensions();
registerGlobalComponents();
registerExtensions();

store.dispatch("initUser").then(() => {
  new Vue({
    router,
    store,
    render: function (h) { return h(App) }
  }).$mount('#app')
});

function initGoogleAnalytics() {
  api.get("/ga", false).then(gaToken => {
    Vue.use(VueGtag, {config: { id: gaToken } }, router);
  });
}

function registerGlobalComponents() {
  const requireComponent = require.context(
    './components/global',
    false,
    /.+\.vue/
  )

  requireComponent.keys().forEach(fileName => {
    const componentConfig = requireComponent(fileName)
    const componentName = fileName
      .replace(/^\.\//, '')
      .replace(/\.\w+$/, '')

    Vue.component(
      componentName,
      componentConfig.default || componentConfig
    )
  })
}
